import { ReverseMatchesRankingTable } from "../model/reverse_matches_ranking_table";
import { Keyword } from "../view/keyword";
import { DashboardsController } from "./dashboards_controller";
import { KeywordRankingController } from "./keyword_ranking_controller";
import $ from "jquery";

interface KeywordRanking {
  type: string;
  title: string;
  valueColumn: string;
  valueUnit: string;
  fixStatsPoint: boolean;
  floorStats: boolean;
}

class ReverseMatchesController extends DashboardsController {
  protected static readonly SCATTERGRAM_FORM_HEIGHT = 635;
  protected static readonly KEYWORD_RANKINGS: KeywordRanking[] = [
    {
      type: "kmr",
      title: "逆マッチ度",
      valueColumn: "指数",
      valueUnit: "%",
      fixStatsPoint: false,
      floorStats: true,
    },
    {
      type: "ksi",
      title: "KSIランキング",
      valueColumn: "KSI値",
      valueUnit: "",
      fixStatsPoint: true,
      floorStats: false,
    },
    {
      type: "ksv",
      title: "季節指数",
      valueColumn: "指数",
      valueUnit: "%",
      fixStatsPoint: false,
      floorStats: true,
    },
  ];

  private keyword: any;

  constructor() {
    super();
  }

  // override
  protected formElement(): JQuery<HTMLElement> {
    return $("#reverse_matches_form");
  }

  protected getXyLabels(): { x: string; y: string } {
    return { x: "KSI", y: "rKMR" };
  }

  protected keywordRankings(): KeywordRanking[] {
    return ReverseMatchesController.KEYWORD_RANKINGS;
  }

  protected createRankingTables(): void {
    const rankingTables = this.keywordRankings().map(
      (ranking) =>
        new ReverseMatchesRankingTable(ranking, this.keywordRankingRoot()),
    );
    this.keywordRankingController = new KeywordRankingController(
      this.form,
      rankingTables,
      this.keywordRankingRoot(),
    );
  }

  onLoad(): void {
    this.view.initialize(
      this.form.canvasElement(),
      this.form.magnification(),
      this.form.location(),
      { height: ReverseMatchesController.SCATTERGRAM_FORM_HEIGHT },
      this.formElement().data("invalidParameterCombinations"),
    );
    this.initializeEventHandlers();
    this.render();
    this.keywordRankingController?.initialize();
    this.keywordRankingController?.render();
    this.keyword = new Keyword($("#keyword"));
    this.keyword.initialize();
  }

  protected fixPoints(points: any[]): any[] {
    const target = this.form.targetDataDate().ymd();
    const partition = this.form.partition();

    return points.map((point) => {
      const [x, y] = this.magicalPointFix(point);
      point.x = x;
      point.y = y;
      point.url = function () {
        const base = this.urlTemplate.replace("@name", this.name);
        return `${base}?selection%5B%5D=${this.id}&type=kmr&partition=${partition}&target=${encodeURIComponent(target)}&max_rank=20&dimension=area&area=`;
      };
      return point;
    });
  }

  private magicalPointFix(point: any): [number, number] {
    return [Math.pow(point.x * 1500, 2), Math.pow(point.y * 5, 2)];
  }
}

export { ReverseMatchesController };
